import React from 'react';
import styled from 'styled-components';
var TooLong = styled.span.withConfig({
  displayName: "Limit__TooLong",
  componentId: "sc-13ze3ed-0"
})(["background-color:#ffc8b8;"]);
export var Limit = function Limit(props) {
  return React.createElement(TooLong, null, props.children);
};